class GTM
{
	sendEvent(eventName, eventParams)
	{
		if (window.google_tag_manager)
		{
			window.dataLayer.push({
				event: eventName,
				...eventParams,
			});

			console.log('GTM event sent:', eventName, eventParams);
		} else
		{
			console.warn('GTM is not loaded.');
		}
	}
}

export default new GTM();